import { ChatRoomList } from 'ui/components/buyer/patterns/ChatRoom/ChatRoomList';

/**
 * 企業系チャットページ
 */
export const BuyerChatRoom: React.FC = () => {
    return <ChatRoomList />;
};
